var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16901 5.39914L2.02127 0.251401C1.68933 -0.080545 1.15114 -0.080545 0.819191 0.251401C0.487245 0.583346 0.487245 1.12154 0.819191 1.45348L5.36589 6.00018L0.819191 10.5469C0.487245 10.8788 0.487245 11.417 0.819191 11.749C1.15114 12.0809 1.68933 12.0809 2.02127 11.749L7.16901 6.60122C7.50096 6.26927 7.50096 5.73108 7.16901 5.39914Z",
    fill: "#007A9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlue);
export default __webpack_public_path__ + "static/media/arrow-right-blue.edc4b73a435ba441f653c851800b2c07.svg";
export { ForwardRef as ReactComponent };